import styled from 'styled-components';

import { DataWrapper } from 'libs/ui';

export const Content = styled(DataWrapper)`
  display: block;
  padding: ${(props) => {
    if (props.tab === 'rfid' || props.tab === 'epm' || props.tab === 'plates' || props.tab === 'subscription') {
      return '0';
    } else {
      return '25px 20px';
    }
  }};
`;
